<template>
  <img ref="image" :src="src" />
</template>

<script setup>
import 'croppie/croppie.css';
import Croppie from 'croppie';
import { ref, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
  src: {
    type: String,
    default: null,
  },
  viewportWidth: {
    type: Number,
    default: 200,
  },
  viewportHeight: {
    type: Number,
    default: 200,
  },
  viewportType: {
    type: String,
    default: 'circle',
  },
  width: {
    type: Number,
    default: 300,
  },
  height: {
    type: Number,
    default: 300,
  },
  outputWidth: {
    type: Number,
    default: null,
  },
  outputHeight: {
    type: Number,
    default: null,
  },
  slider: {
    type: Boolean,
    default: true,
  },
});

const outputWidth = props.outputWidth ?? props.viewportWidth;
const outputHeight = props.outputHeight ?? props.viewportHeight;

const image = ref(null);
let croppie;
onMounted(() => {
  croppie = new Croppie(image.value, {
    boundary: {
      width: props.width,
      height: props.height,
    },
    viewport: {
      width: props.viewportWidth,
      height: props.viewportHeight,
      type: props.viewportType,
    },
    showZoomer: props.slider,
  });
});

onBeforeUnmount(() => {
  if (croppie) {
    croppie.destroy();
  }
});

async function toBase64() {
  return croppie.result({
    type: 'base64',
    size: {
      width: outputWidth,
      height: outputHeight,
    },
    circle: props.viewportType === 'circle',
  });
}

defineExpose({
  toBase64,
});
</script>
